import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import PageHero from "@/components/common/PageHero";
import corporate from "@/assets/images/bobb.jpeg";

const process = [
  "Share logo",
  "Design mockup approval",
  "Printing on umbrella panels",
  "Manufacturing and dispatch",
];

const options = ["Share logo","Color options", "Sizes and frame types", "Packaging customization", "Bulk quantity planning"];

const CorporateBrandingPage = () => {
  useEffect(() => {
    document.title = "Corporate Branding Umbrellas | Keshavlal & Company";
  }, []);

  return (
    <div data-testid="corporate-branding-page-root">
      <PageHero
        eyebrow="Corporate Branding"
        title="Custom Logo Printed Umbrellas for Campaign Visibility"
        description="Designed for procurement teams and brand managers who need durable promotional umbrellas at scale."
        testId="corporate-branding-page-hero"
      />

      <section className="border-b border-slate-200 bg-white" data-testid="corporate-branding-process-section">
        <div className="mx-auto w-full max-w-6xl px-4 py-14 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-semibold text-slate-900" data-testid="corporate-branding-process-title">
            Branding Process
          </h2>
          <div className="mt-8 grid gap-4 md:grid-cols-2" data-testid="corporate-branding-process-grid">
            {process.map((step, index) => (
              <Card key={step} className="rounded-2xl border-slate-200" data-testid={`corporate-branding-process-card-${index}`}>
                <CardContent className="space-y-2 p-5">
                  <p className="text-xs font-semibold uppercase tracking-[0.1em] text-orange-600" data-testid={`corporate-branding-process-step-label-${index}`}>
                    Step {index + 1}
                  </p>
                  <h3 className="text-lg font-semibold text-slate-900" data-testid={`corporate-branding-process-step-title-${index}`}>
                    {step}
                  </h3>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="border-b border-slate-200 bg-slate-50" data-testid="corporate-branding-options-section">
        <div className="mx-auto grid w-full max-w-6xl gap-8 px-4 py-14 sm:px-6 lg:grid-cols-2 lg:px-8">
          <div className="space-y-4" data-testid="corporate-branding-options-content">
            <h2 className="text-3xl font-semibold text-slate-900" data-testid="corporate-branding-options-title">
              Customization Options
            </h2>
            <ul className="space-y-3" data-testid="corporate-branding-options-list">
              {options.map((option) => (
                <li
                  key={option}
                  className="rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700"
                  data-testid={`corporate-branding-option-${option.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {option}
                </li>
              ))}
            </ul>
            <Button
              asChild
              className="rounded-full bg-orange-500 px-6 py-5 text-sm font-semibold text-white hover:bg-orange-600"
              data-testid="corporate-branding-request-quote-button"
            >
              <Link to="/contact" data-testid="corporate-branding-request-quote-link">
                Request Branding Quote
              </Link>
            </Button>
          </div>

          <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white" data-testid="corporate-branding-image-wrapper">
            <img
              src= {corporate}
              alt="Corporate branding umbrellas"
              className="safe-media-image"
              data-testid="corporate-branding-image"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default CorporateBrandingPage;